<ion-split-pane contentId="main-content">
  <ion-menu contentId="main-content" type="overlay" class="sidemenu">
    <ion-content>
      <div class="logo-area">
        <img class="logo" src="./assets/images/ootbo_partner_logo_sm.png" />
      </div>
      
      <div class="user-profile">
        <div class="user" *ngIf="user$ | async as user">
          <ion-row>
            <ion-col size="4" class="center-image">
              <img
              *ngIf="user.profile_image"
              class="pic"
              [src]="user.profile_image"
              />
              <img
                *ngIf="!user.profile_image"
                class="pic"
                [src]="'assets/shared/svg/user-dummy.svg'"
              />
            </ion-col>
            <ion-col size="8">
              <div class="name">{{ user.display_name || user.phone }}</div>
              <a href="javascript:;" (click)="logout()">
                <small class="not-you"> Not you? </small>
              </a>
              <div *ngIf="earnings" class="earnings">
                <p class="earnings_count"><small>Lifetime Earnings:</small><span> ₹{{ earnings.amount }}</span></p>
              </div>
            </ion-col>
          </ion-row>

          <!-- <div *ngIf="earnings" class="earnings">
            <p class="earnings_count"><small>Lifetime Earnings:</small><span> ₹.{{ earnings.amount }}</span></p>
          </div> -->

        </div>
      </div>

      <!-- <div class="profile-area">
        <img class="logo" src="./assets/images/viso-events-se.png" />
        <div class="user" *ngIf="user$ | async as user">
          <img
            *ngIf="user.profile_image"
            class="pic"
            [src]="user.profile_image"
          />
          <img
            *ngIf="!user.profile_image"
            class="pic"
            [src]="'assets/shared/svg/user-dummy.svg'"
          />
          <div class="name">{{ user.name || user.phone }}</div>
          <a href="javascript:;" (click)="logout()">
            <small class="not-you"> Not you? </small>
          </a>
        </div>
        <div *ngIf="earnings" class="earnings">
          <p class="earnings_count"><small>Lifetime Earnings:</small><span> ₹.{{ earnings.amount }}</span></p>
        </div>
      </div> -->
      <ion-list id="inbox-list">
        <ion-menu-toggle auto-hide="false">
          <ion-item
            routerDirection="root"
            [routerLink]="'/profile'"
            lines="none"
            detail="false"
          >
            <div slot="start">
              <ion-icon
                class="menu-icon"
                slot="start"
                name="person-circle-outline"
              ></ion-icon>
            </div>
            <ion-label class="menu-title">My Profile</ion-label>
          </ion-item>

          <ion-item
            routerDirection="root"
            [routerLink]="'/event/list'"
            lines="none"
            detail="false"
          >
            <div slot="start">
              <ion-icon
                class="menu-icon"
                slot="start"
                name="calendar-outline"
              ></ion-icon>
            </div>
            <ion-label class="menu-title">All Events</ion-label>
          </ion-item>

          <ion-item
            routerDirection="root"
            [routerLink]="'/messaging'"
            lines="none"
            detail="false"
          >
            <div slot="start">
              <ion-icon
                class="menu-icon"
                slot="start"
                name="chatbubbles-outline"
              ></ion-icon>
              <span
                *ngIf="count?.isUnreadMessage"
                color="danger"
                class="badge-messages"
              ></span>
            </div>
            <ion-label class="menu-title">Messages</ion-label>
          </ion-item>

          <!-- <ion-item routerDirection="root" [routerLink]="'/pending-approvals'" lines="none" detail="false">
            <div slot="start">
              <ion-icon class="menu-icon" slot="start" name="receipt-outline"></ion-icon>
            </div>
            <ion-label class="menu-title">Requests</ion-label>
          </ion-item> -->

            <!-- <ion-item
            routerDirection="root"
            [routerLink]="'/event/list'"
            lines="none"
            detail="false"
          >
            <div slot="start">
              <ion-icon
                class="menu-icon"
                slot="start"
                name="calendar-outline"
              ></ion-icon>
            </div>
            <ion-label class="menu-title">Event Calendar</ion-label>
          </ion-item> -->

          <ion-item
            routerDirection="root"
            [routerLink]="'/feedback/add'"
            lines="none"
            detail="false"
          >
            <div slot="start">
              <ion-icon
                class="menu-icon"
                slot="start"
                name="bulb-outline"
              ></ion-icon>
            </div>
            <ion-label class="menu-title">Suggestions</ion-label>
          </ion-item>

          <ion-item
            routerDirection="root"
            [routerLink]="'/terms-and-conditions'"
            lines="none"
            detail="false"
          >
            <div slot="start">
              <ion-icon
                class="menu-icon"
                slot="start"
                name="document-outline"
              ></ion-icon>
            </div>
            <ion-label class="menu-title">Terms & Conditions</ion-label>
          </ion-item>

          <ion-item
            routerDirection="root"
            [routerLink]="'/privacy-policy'"
            lines="none"
            detail="false"
          >
            <div slot="start">
              <ion-icon
                class="menu-icon"
                slot="start"
                name="document-lock-outline"
              ></ion-icon>
            </div>
            <ion-label class="menu-title">Privacy Policy</ion-label>
          </ion-item>

          <ion-item
            routerDirection="root"
            [routerLink]="'/help'"
            lines="none"
            detail="false"
          >
            <div slot="start">
              <ion-icon
                class="menu-icon"
                slot="start"
                name="help-circle-outline"
              ></ion-icon>
            </div>
            <ion-label class="menu-title">Help</ion-label>
          </ion-item>

          <div class="center-container" *ngIf="!isNative" >
            <ion-row>
              <a
              href="{{pageData['partner-playstore-link']}}"
              target="_blank"
              >
                <ion-col class="app-link">
                  <ion-icon name="logo-google-playstore"></ion-icon> Play Store
                </ion-col>
              </a>
              <a
              href="{{pageData['partner-appstore-link']}}"
              target="_blank"
              >
                <ion-col class="app-link">
                  <ion-icon name="logo-apple-appstore"></ion-icon> App Store
                </ion-col>
              </a>
            </ion-row>
          </div>
          
          <!-- <ion-item
            routerDirection="root"
            [routerLink]="'/delete-my-account'"
            lines="none"
            detail="false"
          >
            <div slot="start">
              <ion-icon
                class="menu-icon"
                slot="start"
                name="trash-outline"
              ></ion-icon>
            </div>
            <ion-label class="menu-title">Delete My Account</ion-label>
          </ion-item> -->

          <!-- <ion-item routerDirection="root" [routerLink]="'/contact-us'" lines="none" detail="false">
            <div slot="start">
              <ion-icon class="menu-icon" slot="start" name="call-outline"></ion-icon>
            </div>
            <ion-label class="menu-title">Contact Us</ion-label>
          </ion-item> -->
        </ion-menu-toggle>

        <!-- <div class="center-container" *ngIf="!isNative">
          <a
            href="{{pageData['partner-playstore-link']}}"
            target="_blank"
          >
            <ion-label class="app-link">
              <ion-icon name="phone-portrait-outline" class="icon"></ion-icon>
              Experience Ootbo Partner App
            </ion-label>
          </a>
        </div> -->
        
        <ion-item
          lines="none"
          class="logout"
          *ngIf="isNative && isPwa"
          detail="false"
          (click)="exit();"
        >
          <ion-icon
            class="menu-icon"
            slot="start"
            src="./assets/icon/sidemenu/logout.svg"
          ></ion-icon>
          <ion-label class="menu-title">Exit</ion-label>
        </ion-item>
      </ion-list>
      <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button color="primary">
          <ion-icon src="./assets/icon/sidemenu/Vector.svg"></ion-icon>
        </ion-fab-button>
        <ion-fab-list side="start">
          <ion-fab-button
            class="email-button"
            href="mailto:{{pageData['vendor-contact-us-email']}}"
            target="_blank"
          >
            <ion-icon class="email-icon" name="mail-outline"></ion-icon>
          </ion-fab-button>
          <ion-fab-button
            class="phone-button"
            href="tel:{{pageData['vendor-contact-us-mobile']}}"
          >
            <ion-icon class="phone-icon" name="call-outline"></ion-icon>
          </ion-fab-button>
          <ion-fab-button
            class="whatsapp-button"
            href="https://wa.me/{{pageData['vendor-contact-us-mobile']}}"
          >
            <ion-icon class="whatsapp-icon" name="logo-whatsapp"></ion-icon>
          </ion-fab-button>
        </ion-fab-list>
      </ion-fab>
    </ion-content>


    <ion-footer *ngIf="appVersion" class="ion-no-border">
      <p class="ion-text-center">Version {{appVersion}}</p>
    </ion-footer>
  </ion-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-split-pane>
